<template>
  <div>
    <div class="localdiv tright pr15 tc6 pt35 pb15">
      <span class="fs24 fl tc3 lborder prelative pl25 lh10">现任领导</span>
      <div class="pt10">
        当前位置:
        <span>学校首页 > </span>
        <span>学校概况 > </span>
        <span>现任领导</span>
      </div>
    </div>
    <div class="cont tleft pt20 pl40 pr40 pt30 pb40" id="viewer">
      <template v-if="list">
        <div class="teacher mb10 br2 bborder pt15 pb20 pl10" v-for="(item,index) in list" :key="item.id">
          <div class="igs dinline-block vtop ofhidden" v-if="item['picture'][0]">
            <img :src="item['picture'][0]" class="trans3" width="160" height="200">
          </div>
          <div class="txt dinline-block vtop pl15">
            <div class="nm fs26 mb20 pt5 dinline-block">{{item.title}}</div>
            <div class="fs24 tc-red mb20 dinline-block ml15">{{item.description}}</div>
            <div class="fs16 ot tc6 lh18" v-html="item.content"></div>
          </div>
        </div>
      </template>
    </div>
    <pagec :page="page" :total="total" :size="perPage" @get-data="getData" :key="''+id+pid"/>
  </div>
</template>

<script>
import Pagec from "./Page";

export default {
  name: "ListTeacher",
  props:[
    'id',
    'pid',
    'list',
    'total',
    'page',
    'perPage',
    'getData',
  ],
  components:{
    Pagec
  },
  mounted() {
    console.log(this.list)
  },
}
</script>

<style scoped>
  .teacher .sdiv:hover{color: /* #b02e31 */ #364797;}
  .teacher .sdiv:hover img{transform: scale(1.1);}
  .teacher .igs{width: 160px;height: 200px;}
  .teacher .txt{padding: 0 0 0 45px;width: 695px;}
  .teacher .nm{height: 28px;}

</style>



// WEBPACK FOOTER //
// src/components/un_index/ListTeacher.vue